import { Avatar } from "@mui/material"
import LoadingDots from "components/loading-dots"
import AssistantIcon from "../icons/assistant"
import "./style.scss"

export default function AiTeammateThinking() {
  return <div className="ai-teammate-thinking">
    <Avatar className="avatar">
      <AssistantIcon />
    </Avatar>
    <div className="thinking">
      <LoadingDots />
    </div>
  </div>
}
